const photoTags = [
    "Fotostudio", "Studio mit Hintergrundsystem", "Portraitstudio", "Tageslicht-Studio", 
    "Fashion- und Editorial-Studio", "Werbe-Fotostudio", "Still-Life-Studio", 
    "Event- oder Party-Fotostudio", "Produktfotografie-Studio", "Fotoshootings", 
    "Fashion", "offener Raum", "stilvoll", "Industriehalle", "verlassene Fabrik", 
    "Lagerhaus", "Gefängniszelle", "Krankenhaus", "Verhörraum", "Fitnessstudio / Gym", 
    "Luxuswohnung", "Hotelzimmer", "Dachterrasse mit Stadtblick", 
    "Schwimmbad (Indoor oder Outdoor)", "Pool", "Küche", "Restaurantküche", 
    "Bibliothek", "Archiv", "landschaftlicher Garten", "Flugzeug", "Auto", "Oldtimer", 
    "Wartesaal", "Bar", "Club", "Wohnzimmer", "Klassenzimmer", "Büro / Konferenzraum", 
    "Musikclub", "Kino", "Theater", "Labor", "Kirche", "Verkehrsmittel", "Bus", "Zug", 
    "Hafen / Pier", "Wohnwagen", "Mobile Home", "märchenhafte Umgebung", "Fantasy", 
    "Schloss", "Burgruine", "Berghütte", "Blockhütte", "Hütte", "Ausstellungshalle", 
    "Kunstgalerie", "Porträtfotografie", "Modefotografie", "Produktfotografie", 
    "Eventfotografie", "Still-Life-Aufnahmen", "kreative Fotoprojekte", "Werbefotografie", 
    "Outdoor-Shootings", "On-Location-Shootings", "Porträt", "Model", "Hochzeit", 
    "Produkt", "Fashion", "Food", "Still-Life", "Tierfotografie", "Kinder- und Familien", 
    "Sport", "Fitness", "Musik- und Band-Shootings", "Produkt", "Verpackung", 
    "künstlerische", "Street-Fotografie", "Bewerbungsfotos", "Business-Porträts", 
    "Stockfotografie", "Werbung", "Tageslichtdurchflutet", "hohes Deckenlicht", 
    "reflektorbereit", "neutraler Hintergrund", "thematisch dekoriert", "farbenflexibel", 
    "Studioflair", "offener Raum", "dramatische Beleuchtung", "stilvoll", "modular", 
    "helle Beleuchtung"
];

const videoTags = [
    "Videostudio", "Greenscreen-Studio", "Filmstudio", "Musikvideos", 
    "Set für TV-Serien", "Filmset", "Web-Serien-Dreh", "Outdoor", 
    "Studio für Videoproduktionen", "Produktionsstudio", "Industriehalle", 
    "verlassene Fabrik", "Lagerhaus", "Gefängniszelle", "Krankenhaus", "Verhörraum", 
    "Fitnessstudio / Gym", "Luxuswohnung", "Hotelzimmer", "Dachterrasse mit Stadtblick", 
    "Schwimmbad (Indoor oder Outdoor)", "Pool", "Küche", "Restaurantküche", "Bibliothek", 
    "Archiv", "landschaftlicher Garten", "Flugzeug", "Auto", "Oldtimer", "Wartesaal", 
    "Bar", "Club", "Wohnzimmer", "Klassenzimmer", "Büro / Konferenzraum", "Musikclub", 
    "Kino", "Theater", "Labor", "Kirche", "Verkehrsmittel", "Bus", "Zug", "Hafen / Pier", 
    "Wohnwagen", "Mobile Home", "märchenhafte Umgebung", "Fantasy", "Schloss", "Burgruine", 
    "Berghütte", "Blockhütte", "Hütte", "Ausstellungshalle", "Kunstgalerie", "Musikvideos", 
    "Videodreharbeiten", "Filmdreh", "Musikvideo", "TV-Serien", "Werbevideo", 
    "Dokumentarfilm", "Fitness-Video", "Fitness", "Web-Serien-Dreharbeiten", "Podcast", 
    "Drohnenaufnahme", "360°-Videoaufnahmen", "VR-Filme", "Virtual Reality", 
    "Fashion Video", "Modenschau", "Interviews", "Talkshows", "Live-Auftritte", 
    "Produktvorstellungen", "Social Media Content", "Produktvorstellungen", "Produktvideo", 
    "Video Podcast", "Tanz", "Food", "Werbung", "Greenscreen-fähig", 
    "schwarz-weißes Hintergrundstudio", "große Sets", "Beleuchtungskontrolle", 
    "filmische Atmosphäre", "HDR-kompatibel", "4K-Produktionstauglich", 
    "Live-Streaming-fähig", "Drohnenaufnahme", "aufnahmefreundlich", "Szenenvielfalt", 
    "industrial", "retro", "luxuriös", "fantasy", "märchenhaft", "Natur", "Pflanzen", 
    "antik", "historisch", "Meditation", "Yoga", "asiatisch", "mystisch", "Architektur", 
    "kreativ", "bunt"
];  

const musicTags = [
    "Musikstudio", "Professionelles Tonstudio","Home‑Studio", "Projektstudio", "Vocal‑Studio", "Band‑ / Live‑Room‑Studio", "Mixing‑Studio", "Mastering‑Studio", "Produzenten‑Studio", "Beat‑Studio",
"Podcast‑Studio", "Video‑Podcast‑Studio", "Interview‑Studio" , "Roundtable‑Studio",
"Solo‑Recording‑Studio", "Sprachaufnahme‑Studio", "Voice‑over‑Studio", "Musik‑ & Podcast‑Studio",
"Proberaum mit Recording", "Content‑Studio", "Streaming‑ & Live‑Studio", "Musikproduktion", "Professionell",
"Home‑Setup", "Projektbasiert", "Vocal Recording", "Band / Live‑Room", "Mixing", "Mastering",
"Mix & Mastering", "Producing","Beatmaking","Podcast","Video‑Podcast", "Interview",
"Roundtable / Talkrunde", "Solo‑Recording" ,"Sprachaufnahme","Musik & Podcast", "Voice‑over", "Content Creation", "Streaming & Live‑Sessions"
];

export const extractStudioTagValues = (studio) => {
    const rawTags = Array.isArray(studio?.tagValues)
        ? studio.tagValues
        : (Array.isArray(studio?.items) ? studio.items : (studio?.tags?.items || []));

    return rawTags
        .map((tag) => {
            if (typeof tag === "string") return tag;
            return tag?.value ?? tag?.tagValue ?? tag?.name ?? tag?.tag?.name ?? null;
        })
        .filter(Boolean);
};

export const studioHasTagValue = (studio, tagName) => {
    if (!tagName) return false;
    return extractStudioTagValues(studio).includes(tagName);
};

export const getTagsByStudioType = (studioTypes = []) => {
    let tags = new Set();
    const normalizedStudioTypes = Array.isArray(studioTypes) ? studioTypes : [];

    // Wenn alle Typen ausgewählt sind oder keine Typen, zeige alle Tags
    if (normalizedStudioTypes.length === 0 || normalizedStudioTypes.length === 3) {
        return [...new Set([...photoTags, ...videoTags, ...musicTags])];
    }

    // Füge Tags basierend auf den ausgewählten Studiotypen hinzu
    if (normalizedStudioTypes.includes('Foto')) {
        photoTags.forEach(tag => tags.add(tag));
    }
    if (normalizedStudioTypes.includes('Video')) {
        videoTags.forEach(tag => tags.add(tag));
    }
    if (normalizedStudioTypes.includes('Musik')) {
        musicTags.forEach(tag => tags.add(tag));
    }

    return [...tags];
};
